import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MenuItem } from "@/apps/partner/components/MenuItem/MenuItem";
import { MenuCockpit, MenuDevicePlus, MenuUser } from "@/assets/icons/icons";
import { Sidemenu } from "@/components/Layout/Sidemenu/Sidemenu";

export const menuItems = [
  {
    icon: <MenuCockpit />,
    target: "/partner/cockpit",
    text: "layout.menu.items.cockpit",
  },
  {
    icon: <MenuDevicePlus />,
    target: "/partner/add-sim",
    text: "layout.menu.items.devicePlus",
  },
] as const;

export const PartnerPortalSideMenu: FC = () => {
  const { t } = useTranslation();

  return (
    <div id="portal-desktop-sidemenu" className="hidden xl:block">
      <Sidemenu>
        <ul className="z-[2] flex flex-col gap-8 text-white">
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              icon={item.icon}
              text={t(item.text)}
              target={item.target}
            />
          ))}
        </ul>
      </Sidemenu>
    </div>
  );
};
